/** Languages supported for audio transcription and subtitles.
 *  Mirrors `SUPPORTED_LANGUAGES` in `../autoclipper-backend`
 *  (`src/lib/languages/supportedLanguages.js`); keep the codes identical. */
export const SUBTITLE_LANGUAGES: readonly string[] = [
  'pt-BR', 'pt-PT', 'en-US', 'es-ES', 'es-419',
  'fr', 'de', 'it', 'nl', 'da', 'sv', 'no', 'fi', 'et', 'lv', 'lt', 'pl', 'cs', 'sk',
  'hu', 'ro', 'bg', 'el', 'ru', 'uk', 'tr', 'ca', 'id', 'ms', 'vi',
];

/** Subtag before `-`, lowercased. */
export function primaryLanguage(code: string | null | undefined): string {
  return String(code || '').split('-')[0].toLowerCase();
}

/** Translation happens iff the primary subtags differ. A missing side means "same". */
export function isTranslation(
  audioLanguage: string | null | undefined,
  subtitleLanguage: string | null | undefined,
): boolean {
  if (!audioLanguage || !subtitleLanguage) return false;
  return primaryLanguage(audioLanguage) !== primaryLanguage(subtitleLanguage);
}

/** Human name of a language code in the UI language (regions kept for pt-BR,
 *  pt-PT, en-US, es-ES and es-419). Falls back to the code itself. */
export function languageLabel(code: string, uiLanguage: string): string {
  try {
    return new Intl.DisplayNames([uiLanguage], { type: 'language' }).of(code) || code;
  } catch {
    return code;
  }
}
